<template>
    <div>
        <b-card class="standardpage">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="bookings.icon" class="mr-1"></i>
                        {{ bookings.title }}
                        <span v-if="eventcode"> for {{ eventtitle }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-3">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Issue Date" label-size="sm">
                                    <b-input-group>
                                        <daterangepicker size="sm" ref="issued_at" v-model="issued_at" :opens="'right'"
                                            :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true"
                                            :linkedCalendars="false" :single-date-picker="false">
                                        </daterangepicker>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="issued_at = {
                                                startDate: null,
                                                endDate: null,
                                            }
                                                ">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-row>
                                    <b-col>
                                        <b-form-group label="Source" label-for="source" label-cols="12">
                                            <treeselect v-model="source" :clearable="true" :multiple="true"
                                                :options="options_source" placeholder="Show all..."></treeselect>
                                        </b-form-group>
                                    </b-col>

                                    <b-col>
                                        <b-form-group label-cols="12" label="Type" label-size="sm">
                                            <treeselect placeholder="Show all..." searchPromptText="Supplier Type..."
                                                v-model="type" :clearable="true" :multiple="true"
                                                :options="options_suppliertype">
                                            </treeselect>
                                        </b-form-group>

                                        <!-- <b-form-group label="Type" label-for="type" label-cols="12">
                                            <treeselect v-model="type" :clearable="true" :multiple="true"
                                                :options="options_type" placeholder="Show all..."></treeselect>
                                        </b-form-group> -->
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-row>
                                    <b-col>
                                        <b-form-group label="State" label-for="state" label-cols="12">
                                            <treeselect v-model="state" :clearable="true" :multiple="true"
                                                :options="options_state" placeholder="Show all..."></treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group label="Status" label-for="status" label-cols="12">

                                            <treeselect v-model="status" :clearable="true" :multiple="true"
                                                :options="options_status" placeholder="Show all..."></treeselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>


                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Invoice No? ( Paste List )" label-for="reflist" label-cols="12">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <b-form-radio-group id="isinvoiced" v-model="isinvoiced"
                                            :options="options_isinvoiced" size="sm" value-field="id" text-field="label"
                                            name="radio-options" class="z-0" style="padding-top: 0.2em">
                                        </b-form-radio-group>
                                    </b-input-group>
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="reflist" v-model="invoiceno" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste Ref (IA519826,IA519827,...)" size="sm"
                                            class="h-29" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="invoiceno = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col> -->

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Invoice No? ( Paste List )" label-for="reflist" label-cols="12">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <b-form-checkbox-group id="isinvoiced" v-model="isinvoiced"
                                            :options="options_isinvoiced" size="sm" value-field="id" text-field="label"
                                            name="radio-options" class="z-0" style="padding-top: 0.2em">
                                        </b-form-checkbox-group>
                                    </b-input-group>
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="reflist" v-model="invoiceno" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste Ref (IA519826,IA519827,...)" size="sm"
                                            class="h-29" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="invoiceno = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>



                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <span style="padding-top: 0.3em" class="text-primary"
                                            id="slaclike-tooltip">Like</span>
                                        <b-form-checkbox id="slaclike" v-model="slaclike_visible" class="z-0">
                                        </b-form-checkbox>
                                    </b-input-group>
                                    <b-input-group v-if="!slaclike_visible">
                                        <treeselect placeholder="Select slac..."
                                            searchPromptText="Type at least 3 chars..." v-model="slac" :clearable="true"
                                            :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                                            :show-count="true" :flatten-search-results="true"
                                            :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                            :disabled="readonly">
                                            <div slot="value-label" slot-scope="{ node }">
                                                {{ node.raw.id }}
                                            </div>
                                        </treeselect>
                                    </b-input-group>
                                </b-form-group>

                                <b-input-group v-if="slaclike_visible">
                                    <b-form-input v-model="slaclike" :debounce="bookings.debounce"
                                        placeholder="Client SL A/C (LIKE %)" trim></b-form-input>
                                    <b-input-group-append>
                                        <b-button size="sm" variant="outline-secondary" :disabled="!slaclike"
                                            @click="slaclike = ''">
                                            <i class="fa fa-remove"></i>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                                <!-- </b-form-group> -->
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Your Ref/PO" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="yourref" :debounce="bookings.debounce"
                                            placeholder="Your Ref/PO"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!yourref"
                                                @click="yourref = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Event" label-size="sm">
                                    <treeselect placeholder="Select event..."
                                        searchPromptText="Type at least 4 chars..." v-model="eventcode"
                                        :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                                        :matchKeys="['id']" search-nested @select="treeselect">
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col>


                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                                    <b-input-group>
                                        <daterangepicker size="sm" ref="datetravel" v-model="datetravel"
                                            :opens="'right'" :locale-data="locale_data" :ranges="locale_ranges"
                                            :showDropdowns="true" :linkedCalendars="true" :single-date-picker="'range'">
                                        </daterangepicker>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="datetravel = {
                                                startDate: null,
                                                endDate: null,
                                            }
                                                ">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>



                            <b-col cols="12" sm="6" md="4" xl="3">


                                <b-form-group label="ID ( Paste List )" label-for="id" label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="docno" v-model="docno" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste ID (333..,333...)" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>

                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="docno = []">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>


                            <b-col cols="12" sm="6" md="4" xl="3">

                                <b-form-group label="ConfirmNo ( Paste List )" label-for="confirmno" label-cols="12">

                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="confirmno" v-model="confirmno" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste ConfirmNo" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="confirmno = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="TicketNo ( Paste List )" label-for="associatedno" label-cols="12">

                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="associatedno" v-model="associatedno"
                                            tag-variant="primary" separator=" ,;" placeholder="Paste TicketNo" size="sm"
                                            class="h-29" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary"
                                                @click="associatedno = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>

                            </b-col>


                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Locator ( Paste List )" label-for="reflist2" label-cols="12">

                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="reflist2" v-model="locator" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste Locator" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="locator = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>


                            <b-col cols="12" sm="6" md="4" xl="3">

                                <b-form-group label-cols="12" label="Pay By" label-size="sm">
                                    <treeselect v-model="payby" :clearable="true" :multiple="true"
                                        :options="payby_options">
                                    </treeselect>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Supplier B/L" label-size="sm">
                                    <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..."
                                        v-model="blac" :clearable="true" :async="true"
                                        :load-options="treeselect_loadBLAC" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Passenger" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="passenger" placeholder="Passenger" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!passenger"
                                                @click="passenger = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-row>
                                    <b-col>
                                        <b-form-group label-cols="12" label="Details" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="details" :debounce="bookings.debounce"
                                                    placeholder="Details"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" :disabled="!details"
                                                        @click="details = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group label-cols="12" label="Agent" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="agent" placeholder="Agent" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" :disabled="!agent"
                                                        @click="agent = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group> </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                                    <b-input-group>
                                        <b-form-datepicker size="sm" v-model="datetravel" label-help hide-header
                                            locale="en-GB" placeholder="Date Travel" :debounce="bookings.debounce"
                                            :date-format-options="{
                                                year: 'numeric',
                                                month: 'numeric',
                                                day: 'numeric',
                                            }"></b-form-datepicker>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!datetravel"
                                                @click="datetravel = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col> -->




                        </b-row>
                    </b-card-body>
                </b-card>

                <div class="px-3">
                    <!-- {{ bookings.offset }} {{ bookings.limit }} {{ bookings.page }} -->
                    <d-table classdivtable="availtable datatable" refid="bookingforms" :icon="bookings.icon"
                        :toolbarlibrary="bookings.toolbarlibrary" :tools="bookings.tools" :icons="bookings.icons"
                        :badges="bookings.badges" :fields="bookings.fields" :items="bookings.items"
                        :busy="bookings.busy" :offset="bookings.offset" :limit="bookings.limit" :page="bookings.page"
                        :showpages="true" @load="bookings_load" @click="bookings_click" @select="bookings_select">
                    </d-table>

                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="bookings.selected" :config="cconfig"
                    @discard="bookings_click('discard')"></component>
            </div>

            <b-row class="px-3">
                <b-col>
                    <b-alert :show="message ? true : false" variant="success">
                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                            <b-col>
                                <span v-html="message"></span></b-col></b-row>
                    </b-alert></b-col>
            </b-row>

        </b-card>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import BookingsAssign from "../Accounts/Components/BookingsAssign";
import BookingsEdit from "../Accounts/Components/BookingsEdit";
import BookingsInvoice from "../Accounts/Components/BookingsInvoice";
import BookingsVoucher from "../Accounts/Components/BookingsVoucher";
import HotelVoucher from "../Bookings/Components/HotelVoucher";

// import DraftInvoiceWizard from "./Components/DraftInvoiceWizard";


export default {
    name: "Bookings",
    components: {
        BookingsAssign,
        BookingsEdit,
        BookingsInvoice,
        BookingsVoucher,
        HotelVoucher
        // DraftInvoiceWizard,

    },
    async mounted() {
        await this.accessdenied();
        try {
            const response = await this.$apollo.query({
                query: gql`
                        query suppliertypes {
                        suppliertypes {
                            id
                            label
                            faicon
                        }
                        }
                    `,
            });
            // this.options_suppliertype = response.data.suppliertypes;
            this.options_suppliertype = response.data.suppliertypes.filter(o => o.faicon != '');
        } catch (error) {
            console.log(error);
        }
    },
    watch: {
        async issued_at() {
            console.log('watch issued_at')
            await this.bookings_load(0);
        },
        async type() {
            console.log('watch type')
            await this.bookings_load(0);
        },
        async source() {
            console.log('watch source')
            await this.bookings_load(0);
        },
        async state() {
            console.log('watch state')
            await this.bookings_load(0);
        },
        async passenger() {
            console.log('watch passenger')
            await this.bookings_load(0);
        },
        async slaclike_visible() {
            console.log('watch slaclike_visible')
            await this.bookings_load(0);
        },
        async blac() {
            console.log('watch blac')
            await this.bookings_load(0);
        },
        async slac() {
            console.log('watch slac')
            await this.bookings_load(0);
        },
        async slaclike() {
            console.log('watch slaclike')
            await this.bookings_load(0);
        },
        async associatedno() {
            console.log('watch associatedno')
            await this.bookings_load(0);
        },
        async confirmno() {
            console.log('watch confirmno')
            if (this.confirmno.length > 0) {
                this.issued_at = { startDate: null, endDate: null }
                await this.bookings_load(0);
            } else {
                this.issued_at = { startDate: this.$moment().startOf("year").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
            }
        },
        async locator() {
            console.log('watch locator')
            if (this.locator.length > 0) {
                this.issued_at = { startDate: null, endDate: null }
                await this.bookings_load(0);
            } else {
                this.issued_at = { startDate: this.$moment().startOf("year").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
            }
        },
        async invoiceno() {
            console.log('watch invoiceno')
            if (this.invoiceno.length > 0) {
                this.issued_at = { startDate: null, endDate: null }
                this.isinvoiced = ["1"]
                await this.bookings_load(0);
            } else {
                this.isinvoiced = ["0"]
                this.issued_at = { startDate: this.$moment().startOf("year").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
            }
        },
        async datetravel() {
            console.log('watch datetravel')
            await this.bookings_load(0);
        },
        async eventcode() {
            console.log('watch eventcode')
            await this.bookings_load(0);
        },
        async agent() {
            console.log('watch agent')
            await this.bookings_load(0);
        },
        async status() {
            console.log('watch status')
            await this.bookings_load(0);
        },
        async isinvoiced() {
            console.log('watch isinvoiced')
            if (this.isinvoiced) {
                if (JSON.stringify(this.isinvoiced) == '["0","1"]') {
                    this.isinvoiced = ["1"]
                } else if (JSON.stringify(this.isinvoiced) == '["1","0"]') {
                    this.isinvoiced = ["0"]
                }
            }
            await this.bookings_load(0);
        },
        async payby() {
            console.log('watch payby')
            await this.bookings_load(0);
        },
        async reason() {
            console.log('watch reason')
            await this.bookings_load(0);
        },
        async yourref() {
            console.log('watch yourref')
            await this.bookings_load(0);
        },
        async details() {
            console.log('watch details')
            await this.bookings_load(0);
        },
        async docno() {
            console.log('watch docno')
            await this.bookings_load(0);
        },

        "window.width": {
            immediate: true,
            async handler(newVal, oldVal) {
                console.log('window.width', newVal)
                if (newVal < 1500) {

                    this.bookings.fields[5].class = "d-none"
                    this.bookings.fields[6].class = "d-none"
                    this.bookings.fields[7].class = "d-none"
                    this.bookings.fields[8].class = "d-none"
                    this.bookings.fields[16].class = "d-none"
                    this.bookings.fields[17].class = "d-none"
                    this.bookings.fields[25].class = "d-none"
                    this.bookings.fields[26].class = "d-none"
                } else {
                    this.bookings.fields[5].class = "text-center"
                    this.bookings.fields[6].class = "text-center"
                    this.bookings.fields[7].class = "text-center"
                    this.bookings.fields[8].class = "text-center"
                    this.bookings.fields[16].class = "text-center"
                    this.bookings.fields[17].class = "text-center"
                    this.bookings.fields[25].class = "text-center"
                    this.bookings.fields[26].class = "text-center"
                }
                // // HIDE COLUMNS BELOW WIDTH
                if (newVal < 1950) {
                    this.bookings.fields[9].class = "d-none"
                    this.bookings.fields[10].class = "d-none"
                    this.bookings.fields[11].class = "d-none"
                    this.bookings.fields[12].class = "d-none"
                    this.bookings.fields[13].class = "d-none"
                    this.bookings.fields[14].class = "d-none"
                    this.bookings.fields[15].class = "d-none"
                } else {
                    this.bookings.fields[9].class = "text-center"
                    this.bookings.fields[10].class = "text-center"
                    this.bookings.fields[11].class = "text-center"
                    this.bookings.fields[12].class = "text-center"
                    this.bookings.fields[13].class = "text-center"
                    this.bookings.fields[14].class = "text-center"
                    this.bookings.fields[15].class = "text-center"
                }
            },
        },
    },
    data() {
        return {
            busy: false,
            readonly: false,
            showfilter: false,
            message: null,
            issued_at: {
                startDate: this.$moment().add(-1, 'M').startOf("month").format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            //datetravel: null,
            datetravel: {
                startDate: this.$moment().startOf("year").format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            confirmno: [],
            associatedno: [],
            invoiceno: [],
            slac: [],
            slaclike: null,
            slaclike_visible: null,
            blac: null,
            yourref: null,
            details: null,
            docno: [],
            passenger: null,
            locator: [],
            eventcode: null,
            agent: null,
            type: [],
            options_suppliertype: [],
            source: ["GDS"],
            options_source: [
                { id: "GDS", label: "GDS" },
                { id: "BOP", label: "BOP" },
            ],
            state: ["1"],
            options_state: [
                { id: "0", label: "Unsubmit" },
                { id: "1", label: "Submit" },
                // { id: "2", label: "Invoiced" },
            ],
            status: ["HK"],
            options_status: [
                { id: "HK", label: "Confirm" },
                { id: "VD", label: "Void" },
            ],
            isinvoiced: [],
            options_isinvoiced: [
                { id: '1', label: 'Yes' },
                { id: '0', label: 'No' },
            ],
            reason: null,
            reason_options: [],
            payby: [],
            payby_options: [],
            bookings: {
                title: "Bookings (GDS)",
                icon: "fa fa-globe text-primary",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                denied: [],
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-retweet text-teal",
                        position: "toolbar",
                        action: "rebuild",
                        label: "Rebuild",
                        disabled: true,
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-share text-info",
                        position: "toolbar,actions",
                        action: "assign",
                        label: "Assign",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-commenting-o",
                        position: "toolbar",
                        action: "notes",
                        label: "Notes",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-repeat text-orange",
                        position: "toolbar",
                        action: "migrate",
                        label: "Migrate",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-ticket text-orange",
                        position: "toolbar,actions",
                        action: "voucher",
                        label: "Voucher",
                        component: {
                            name: "",
                        },
                    },
                ],
                tools:
                    "go,filter,export,clipboard,migrate,add,edit,deleteconfirm,assign,invoice,voucher",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "issued_at",
                        label: "Issued",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY HH:mm:SS");
                            }
                            return result;
                        },
                    },
                    {
                        key: "source",
                        label: "Source",
                        sortable: true,
                        class: "text-center",
                    },
                    // {
                    //     key: "docno",
                    //     label: "DocNo",
                    //     sortable: true,
                    //     class: "text-center",
                    // },
                    {
                        key: "locator",
                        label: "Locator",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "confirmno",
                        label: "ConfirmNo",
                        sortable: true,
                        class: "text-center",
                    },
                    // {
                    //     key: "subject",
                    //     label: "Subject",
                    //     sortable: true,
                    //     class: "text-center",
                    //     formatter: (value, key, item) => {
                    //         let result = value;
                    //         if (result) {
                    //             if (result.length > 30) {
                    //                 result = result.slice(0, 27) + "...";
                    //             }
                    //         }
                    //         return result;
                    //     },
                    // },
                    {
                        key: "pax",
                        label: "Trv",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "qty",
                        label: "Seg",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "passenger",
                        label: "Passenger",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "days",
                        label: "Days",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "startcity",
                        label: "StartCity",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "start_at",
                        label: "Start Date",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "end_at",
                        label: "End Date",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY HH:mm");
                            }
                            return result;
                        },
                    },
                    // {
                    //     key: "endcity",
                    //     label: "EndCity",
                    //     sortable: true,
                    //     class: "text-center",
                    // },
                    {
                        key: "equipment",
                        label: "Equipment",
                        sortable: true,
                        class: "text-center",
                    },
                    // {
                    //     key: "payby",
                    //     label: "Pay By",
                    //     sortable: true,
                    //     class: "text-center",
                    // },
                    // {
                    //     key: "blac",
                    //     label: "BL A/C",
                    //     sortable: true,
                    //     class: "text-center",
                    // },
                    {
                        key: "bltotal",
                        label: "Cost",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "sltotal",
                        label: "Sales",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-center",
                    },
                    // {
                    //     key: "state",
                    //     label: "State",
                    //     sortable: true,
                    //     formatter: (value, key, item) => {
                    //         switch (value) {
                    //             case 0:
                    //                 return "unsubmit";
                    //             case 1:
                    //                 return "submit";
                    //             case 2:
                    //                 return "invoiced";
                    //             default:
                    //                 return value;
                    //         }
                    //     }
                    // },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },
                ],
                icons: [
                    {
                        key: "type",
                        H: "fa fa-bed text-orange w-15px text-center",
                        C: "fa fa-car text-info w-15px text-center",
                    }
                ],
                badges: [
                    {
                        key: "confirmno",
                        type: "pill",
                        class: "orange",
                    },
                    {
                        key: "docno",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "locator",
                        type: "pill",
                        class: "secondary",
                    },
                    {
                        key: "qty",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "pax",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "equipment",
                        type: "pill",
                        class: "purple",
                    },
                    {
                        key: "payby",
                        type: "pill",
                        class: "secondary",
                    },
                    {
                        key: "blac",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "days",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "source",
                        type: "badge",
                        BOP: "purple",
                        GDS: "success",
                    },
                    {
                        key: "state",
                        type: "badge",
                        unsubmit: "warning",
                        submit: "danger",
                        invoiced: "primary",
                    },
                ]
            }
        };
    },
    computed: {
        ...mapGetters(["window"]),
    },
    methods: {
        accessdenied() {
            this.bookings.denied = [];
            if (!this.user.permissions.includes("systems.development")) {
                this.bookings.denied.push("wizard");
            }
            if (!this.user.permissions.includes("systems.development")) {
                this.bookings.denied.push("migrate");
            }
            if (!this.user.permissions.includes("bookings.delete")) {
                this.bookings.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("bookings.save")) {
                this.bookings.denied.push("save");
            }
            if (!this.user.permissions.includes("bookings.admin")) {
                this.bookings.denied.push("add");
            }

            if (!this.user.permissions.includes("bookings.admin")) {
                this.agent = this.user.initials
            } else {
                this.state = ["1"]
            }

        },
        async bookings_load(offset, limit, page) {

            console.log('bookings_load', offset, limit, page)
            this.message = null

            let state = this.bookings

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true

            let variables = {
                offset: state.offset,
                limit: state.limit,
                issued_at: [
                    this.issued_at.startDate
                        ? this.$moment(this.issued_at.startDate).format("YYYY-MM-DD")
                        : null,
                    this.issued_at.endDate
                        ? this.$moment(this.issued_at.endDate).format("YYYY-MM-DD")
                        : null,
                ],
                source: this.source.length > 0 ? this.source.join(",") : null,
                type: this.type.length > 0 ? this.type.join(",") : null,
                state: this.state.length > 0 ? this.state.join(",") : null,
                //travel_at: [this.datetravel, this.datetravel],
                travel_at: [
                    this.datetravel.startDate
                        ? this.$moment(this.datetravel.startDate).format("YYYY-MM-DD")
                        : null,
                    this.datetravel.endDate
                        ? this.$moment(this.datetravel.endDate).format("YYYY-MM-DD")
                        : null,
                ],
                confirmno: this.confirmno.length > 0 ? this.confirmno.join(",") : null,
                associatedno: this.associatedno.length > 0 ? this.associatedno.join(",") : null,
                slac: this.slac.length > 0 ? this.slac.join(",") : null,
                slaclike: this.slaclike,
                passenger: this.passenger,
                invoiceno: this.invoiceno.length > 0 ? this.invoiceno.join(",") : null,
                isinvoiced: this.isinvoiced.length > 0 ? this.isinvoiced == "1" ? true : false : null,
                locator: this.locator.length > 0 ? this.locator.join(",") : null,
                status: this.status.length > 0 ? this.status.join(",") : null,
                eventcode: this.eventcode,
                agent: this.agent,

                blac: this.blac,
                // reason: this.reason.length > 0 ? this.reason.join(",") : null,
                payby: this.payby.length > 0 ? this.payby.join(",") : null,
                yourref: this.yourref,
                docno: this.docno.length > 0 ? this.docno.join(",") : null,
                details: this.details,
                dateformat: "DD/MM/YYYY HH:MM:SS",
            };

            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
              query bookings(             
                $offset: Int
                $limit: Int
                $issued_at: [String]
                $type: String   
                $source: String   
                $state: String 
                $docno: String       
                $confirmno: String
                $associatedno: String
                $travel_at: [String]
                $slac: String
                $slaclike: String
                $blac: String
                $passenger: String                    
                $invoiceno: String
                $locator: String              
                $eventcode: String
                $agent: String               
                $status: String             
                $isinvoiced: Boolean    
                $reason: String
                $payby: String
                $yourref: String
                $details: String        
                $dateformat: String
              ) {
                    bookings(                 
                    offset: $offset
                    limit: $limit
                    issued_at: $issued_at
                    type: $type
                    source: $source 
                    state: $state  
                    docno: $docno                
                    confirmno: $confirmno
                    associatedno: $associatedno
                    travel_at: $travel_at
                    passenger: $passenger                                   
                    invoiceno: $invoiceno               
                    locator: $locator
                    slac: $slac
                    slaclike: $slaclike
                    blac: $blac
                    yourref: $yourref
                    reason: $reason
                    payby: $payby
                    details: $details
                    eventcode: $eventcode
                    agent: $agent                
                    status: $status
                    isinvoiced: $isinvoiced                
                    dateformat: $dateformat
                    ) {
                    id
                    issued_at
                    source
                    type
                    docno
                    locator  
                    subject
                    pax   
                    passenger
                    days
                    qty
                    startcity
                    start_at
                    end_at
                    endcity
                    equipment
                    payby
                    blac  
                    bltotal
                    sltotal
                    slac
                    eventcode             
                    agent
                    invoiceno  
                    confirmno              
                    state
                    updated_at
                    updated_by
                    rows
                    }
                }
                `,
                    variables,
                });

                // USE LOCAL VARIABLE
                if (limit == 0) {
                    state.selected = response.data.bookings
                } else {
                    state.items = response.data.bookings;
                }

            } catch (error) {
                console.log(error);
            }

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bookingformspaytypes {
                            bookingformspaytypes {
                                id
                                label
                            }
                        }
                    `,
                });
                this.payby_options = response.data.bookingformspaytypes;
            } catch (error) {
                console.log(error);
            }

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query bookingformsreasontypes {
              bookingformsreasontypes {
                id
                label: name
              }
            }
          `,
                });
                this.reason_options = response.data.bookingformsreasontypes;
            } catch (error) {
                console.log(error);
            }


            state.busy = false;

            this.$store.dispatch("bookings");

        },

        async bookings_click(a, ss) {

            let state = this.bookings

            switch (a) {
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    break;
                case "go":
                    this.component = null;
                    //   this.dateSelector();
                    await this.bookings_load(0);
                    break;
                case "add":
                case "edit":
                    this.component = "BookingsEdit";
                    break;
                case "wizard":
                    await this.bookings_rebuild(ss)
                    // this.$bvModal.show("draftinvoices-wizard");
                    break;
                case "rebuild":
                    await this.bookings_rebuild(ss)
                    break;
                case "migrate":
                    this.migrateit(ss);
                    break;
                case "delete":
                    this.deleteit(ss);
                    break;

                case "assign":
                    this.message = ""
                    this.component = "BookingsAssign";
                    break;

                case "invoice":
                    if (ss.length > 0) {
                        if (ss[0].invoiceno) {
                            this.message = null
                            this.component = "BookingsInvoice";
                        } else {
                            this.message = "Invoice has not been posted yet! use <i class='fa fa-share text-info'></i> Assign to draft an invoice."
                            this.component = null;
                        }
                    }
                    break;

                case "voucher":
                    if (ss[0].type == 'C') {
                        this.message = null
                        this.component = "BookingsVoucher"
                    }
                    else if (ss[0].type == 'H') {
                        this.message = null
                        this.component = "HotelVoucher"
                    }
                    else {
                        this.message = "Booking type does not have a voucher."
                        this.component = null;
                    }
            }
        },
        async bookings_select(ss, tools) {
            this.message = null
            let state = this.bookings

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = [
                    "back",
                    "save",
                    "go",
                    "filter",
                    "clipboard",
                    "add",
                    "export",
                    "migrate",
                    "assign"
                ];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1            
                //   , "receiptview"
                enabled = ["edit", "clone", "notes", "invoice", "voucher", "assign", "wizard", "rebuild"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                //, "submit", "receiptemail"
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        async migrateit(s) {

            let state = this.bookings

            state.busy = true
            let variables = {
                updated_at: ['2023-10-01', this.$moment().format('YYYY-MM-DD')],
            };
            console.log(variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation bookings_migrate($updated_at: [String]) {
                bookings_migrate(updated_at: $updated_at) {
                  id
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            state.busy = false
            await this.bookings_load(0);
        },
        async deleteit(s) {
            console.log("deleteit", s);

            let rows = [];
            s.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            console.log(variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation bookings_delete($rows: [Booking_input]) {
                bookings_delete(rows: $rows) {
                  id
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.bookings_load(0);
        },


    },
};
</script>